import React, { useEffect, useState } from 'react';
import { LocalWebLink } from '../Config/constants';
import { Link, useLocation } from 'react-router-dom';

const NavigationBar = () => {
    const location = useLocation();
    const currentPath = location.pathname + location.hash;

    const [showNav, setShowNav] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 150) {
                setShowNav(true);
            } else {
                setShowNav(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);


    return (
        <div className={`__navigationBar ${showNav ? 'show' : 'hide'}`}>

            <ul className="nav">
                {LocalWebLink.map((val, index) => (
                    <li className="nav-item" key={index}>
                        {val.link ?
                            <Link to={val.linkUrl} className={`nav-link ${currentPath === val?.linkUrl ? 'active' : ''}`}>
                                <span> {val.icon}</span>
                                <p>{val.name}</p>
                            </Link>
                            :
                            <a href={val.linkUrl}
                                onClick={() => window.location.hash = val.linkUrl}
                                className={`nav-link ${currentPath === val?.linkUrl ? 'active' : ''}`}>
                                <span> {val.icon}</span>
                                <p>{val.name}</p>
                            </a>
                        }
                    </li>
                ))}
            </ul>

        </div>
    );
}

export default NavigationBar;
